<agr-page-toolbar
  [pageTitle]="this.translate('title')"
  [hasPrimaryAction]="allowedToCUD$ | async"
  primaryActionIcon="add"
  [primaryActionText]="'add' | translate"
  (primaryAction)="createFeedAdvice()"
  data-test="feed-advice-overview"
>
  <ng-container actions>
    <mat-select
      *ngIf="isReferenceFeedAdvice"
      [hideSingleSelectionIndicator]="true"
      class="flex__child--auto spacing--margin-right text--small headerSelector"
      data-placeholder="{{ 'region' | translate }}"
      data-test="country-selector"
      (selectionChange)="changeRegionSelection($event)"
      [value]="selectedRegion$ | async"
    >
      <mat-option *ngFor="let region of regions" [value]="region.id">
        {{ 'regions.' + region.id | translate }}
      </mat-option>
    </mat-select>

    <mat-select
      *ngIf="(locations$ | async) && !isReferenceFeedAdvice"
      multiple
      class="flex__child--auto spacing--margin-right text--small headerSelector"
      data-placeholder="{{ 'feed-advice-overview.location-selector' | translate }}"
      data-test="location-selector"
      (selectionChange)="changeLocation($event)"
      [compareWith]="areLocationsEqual"
      [value]="selectedLocations"
    >
      <mat-option *ngFor="let location of locations$ | async" [value]="location">
        {{ location.name }}
      </mat-option>
    </mat-select>

    <mat-select
      multiple
      class="flex__child--auto spacing--margin-right text--small headerSelector"
      data-placeholder="{{ 'select-feed-advice-type.label' | translate }}"
      data-test="feedadvicetype-selector"
      (selectionChange)="changeFeedAdviceTypeSelection($event)"
      [value]="selectedFeedAdviceTypes"
    >
      <mat-option
        *ngFor="let feedAdviceType of feedAdviceTypesForSelector"
        [value]="feedAdviceType"
      >
        {{ 'select-feed-advice-type.' + feedAdviceType | translate }}
      </mat-option>
    </mat-select>
  </ng-container>

  <ng-container *ngIf="tableConfig$ | async as tableConfig">
    <agr-table
      *ngIf="(isLoading$ | async) === false"
      [emptyTitle]="this.translate('no-advices.title')"
      [emptyDescription]="this.translate('no-advices.description')"
      emptyImage="assets/images/pigs_001.jpg"
      [config]="tableConfig"
      class="table"
    ></agr-table>
  </ng-container>
</agr-page-toolbar>

<ng-template #nameTemplate let-row="row">
  <a
    (click)="viewFeedAdvice(row.id, isReferenceFeedAdvice)"
    class="button"
    data-test="table-desktop__col-actions-view"
    >{{ row.name ?? 'No name' }}</a
  >
</ng-template>
